/* eslint-disable */
import React, { Component } from 'react'
import AgGridTable from '../agGrid/agGridTable'
import ReadAxios from '../axiosComponent/readAxios'
import ActionButton from './viewButton'
import ApproveButton from './approveButton'
import Loader from '../loadingComponent/Loader'
import moment from 'moment'
import Axios from 'axios'
import { post } from 'jquery'
import { JWT_TOKEN } from '../../constants'
import cityNameRenderer from './cityName'
import 'moment-timezone';
// import { connect } from 'react-redux'
export default class TransporterTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowItems: [],
            update: false,
            search_value: '',
            loadingData: true,
            isLoaded: false,
            cityItems: [],
            cityName: ""
        }
    }

    componentDidUpdate(props) {
        if (this.state.update) {
            this.setState({ update: false })
            this.getData()
        }
    }
    getData = () => {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/vendors/`, method: "get",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    rowItems: res.data.resultSet,
                    isLoaded: true,
                })
                console.log("get api result : ", this.state.rowItems)
            }
        })
    }
    componentDidMount() {
        this.getData()
    }
    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }

    getCityName = async (city_code) => {
        // let namecity = ""
        //   let res =  await ReadAxios({
        //         masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${city_code}`, method:"post", 
        //     });

        //   let nameC = res.data.resultSet[0] ? res.data.resultSet[0]['cityName'] : ""
        // .then((res) => {
        //     namecity = res.data.resultSet[0] ? res.data.resultSet[0]['cityName'] : ""
        // })
        // if (res.status === 200) {
        //     var cityname = res.data.resultSet[0] ? res.data.resultSet[0]['cityName'] : ""
        //     namecity = `${cityname}`
        //     console.log("name ",namecity)
        // }
        // console.log("hiiiiiiiiiiiii",nameC)
        // return nameC
    }

    render() {
        let timezone = localStorage.getItem("timezone");

        if (!this.state.isLoaded) {
            return <Loader />
        }
        else {

            let columnDefs = [
                { headerName: 'Company Name', field: 'transporterName', tooltipField: 'orderNo', enableRowGroup: true, enablePivot: true },
                { headerName: 'ID', field: 'transporterMasterId', hide: true, tooltipField: 'transporterMasterId', enableRowGroup: true, enablePivot: true },
                { headerName: 'Registration Date', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true },
                { headerName: 'Address', field: 'companyAddress', tooltipField: 'companyAddress', enableRowGroup: true, enablePivot: true },
                { headerName: 'City', field: 'address', tooltipField: 'address', enableRowGroup: true, enablePivot: true, cellRenderer: 'cityNameRender' },
                { headerName: 'Date & Time', field: 'date', tooltipField: 'date', enableRowGroup: true, enablePivot: true },
                { headerName: 'Status', field: 'status', tooltipField: 'status', enableRowGroup: true, enablePivot: true },
                { headerName: 'Vehicle Details', field: 'sdate', cellRenderer: 'actionRenderer', suppressToolPanel: true },
                { headerName: 'Approve/Reject', field: 'edit', cellRenderer: 'approveRenderer', suppressToolPanel: true },
            ]
            let rowData = []

            if (this.state.rowItems) {
                this.state.rowItems.map((o, i) => {
                    let temp = {}
                    temp.transporterName = o.transporterName
                    temp.id = o.transporterMasterId
                    temp.createdOn = moment.tz(o.createdOn, timezone).format('DD-MM-YYYY HH:mm')
                    temp.companyAddress = o.companyAddress
                    // let cityName = this.getCityName(o.companyCity)
                    temp.address = o.companyCity
                    temp.date = moment.tz(o.createdOn, timezone).format('DD-MM-YYYY HH:mm')
                    temp.status = o.isApproved == 0 && o.isRejected == 0 ? "-" : o.isApproved == 1 ? "Approved" : "Rejected"
                    rowData[i] = temp
                })
            }
            else {
                rowData[0] = ""
            }

            let framerComponent = {
                cityNameRender: cityNameRenderer
            }
            return (
                <div>
                    <AgGridTable
                        isLoading={this.state.loadingData}
                        columnDefs={columnDefs}
                        extraComponents={framerComponent}
                        hiddenOEBtn={true}
                        exporthidden={true}
                        importhidden={true}
                        hiddenNew={true}
                        hidePopNew={true}
                        pagination={true}
                        loading={this.state.loading}
                        serverData={this.state.rowItems}
                        titleBarTitle={"Partner Onboarding"}
                        actionButton={ActionButton}
                        approveButton={ApproveButton}
                        updated={this.updated}
                        rowData={rowData}
                        baseURL={this.props.locationHistory}
                    />
                </div>
            )
        }
    }
}
